import { useState } from "react";
import { Request } from "../../hooks/Request";
import { H2, H3, Anchor } from "../Text";

const ListDocumentMosaico = (props) => {
  const {
    urlApi,
  } = props;
  const { data } = Request({
    urlApi: urlApi,
  });

  return (
    <ViewDocuments listDocument={data} />
  );
};

const ViewDocuments = ({ listDocument }) => {
  const [viewImage, setviewImage] = useState();
  const listExtension = ["png", "gif", "jpeg", "jpg"];
  return (
    <>
      <div className="flex flex-col gap-2 p-2">
        <H2>Lista de documentos</H2>
        {
          listDocument && listDocument.length > 0 ?
            listDocument?.map((document, idx) => {
              const extension = document.url ? document.url.split(".") : "";
              return listExtension.indexOf(extension[extension.length - 1]) > -1 ? (
                <div
                  key={idx}
                  onClick={() => setviewImage(document.url)}
                  className="flex items-center gap-2 cursor-pointer"
                >
                  <img
                    className="w-[200px] h-20 bg-white rounded-md"
                    src={document.url}
                    alt=""
                  />
                  <div className="flex flex-col items-start max-w-[400px]">
                    <h3 className="font-semibold">{document.name}</h3>
                    <h3>{document.originalName}</h3>
                  </div>
                </div>
              ) :

                document?.url ?
                  (
                    <Anchor
                      key={idx}
                      href={document?.url || "#"}
                      target={document?.url ? "_blank" : undefined}
                      rel={document?.url ? "noopener noreferrer" : undefined}
                      className="flex items-center gap-2"
                    >
                      <div className="w-[200px] h-20 bg-white rounded-md flex justify-center items-center">
                        <H3 className="text-blue-500 text-2xl uppercase">
                          {extension[extension.length - 1]}
                        </H3>
                      </div>
                      <div className="flex flex-col items-start max-w-[400px]">
                        <h3 className="font-semibold">{document?.name || "Documento sin nombre"}</h3>
                        <h3>{document?.originalName || "Nombre original no disponible"}</h3>
                      </div>
                    </Anchor>
                  )
                  :
                  null
            })
            :
            <div className="text-center text-gray-500">(Sin documentos para mostrar)</div>
        }
        <br />
      </div>

      {viewImage ? (
        <div
          className={
            "z-40 h-screen w-full bg-black/50 fixed top-0 right-0 duration-300 left-0 flex justify-center items-center"
          }
          onClick={() => setviewImage(null)}
        >
          <div className="h-[100%] w-[100%] absolute"></div>
          <div className="max-h-screen overflow-y-auto bg-slate-200 relative bg-inherit rounded-lg">
            <img className="h-[90vh] rounded-md" src={viewImage} alt="" />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ListDocumentMosaico;
